export const invoiceStatuses = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "submitted",
    label: "Submitted",
  },
  {
    value: "valid",
    label: "Valid",
  },
  {
    value: "invalid",
    label: "Invalid",
  }
];